import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CourseData, CourseEntity, CourseId } from 'course-types';

interface COURSE_STATE_TYPE {
  activeCourseData: CourseData;
  courseList: Array<CourseEntity>;
  isEditingCourseData: boolean;
  adminStudentView: boolean;
}

const INITIAL_STATE: COURSE_STATE_TYPE = {
  activeCourseData: { id: '' as CourseId, name: '', image: null, units: {} },
  courseList: [],
  isEditingCourseData: false,
  adminStudentView: false,
};

const courseSlice = createSlice({
  name: 'course',
  initialState: INITIAL_STATE,
  reducers: {
    setActiveCourseData(state: COURSE_STATE_TYPE, action: PayloadAction<CourseData>) {
      state.activeCourseData = action.payload;
    },
    setCourseList(state: COURSE_STATE_TYPE, action: PayloadAction<Array<CourseEntity>>) {
      state.courseList = action.payload;
    },
    addToCourseList(state: COURSE_STATE_TYPE, action: PayloadAction<CourseEntity>) {
      state.courseList.push(action.payload);
    },
    deleteCourse(state, action: PayloadAction<string>) {
      state.courseList = state.courseList.filter((course) => course.id !== action.payload);
    },
    setisEditingCourseData(state: COURSE_STATE_TYPE, action: PayloadAction<boolean>) {
      state.isEditingCourseData = action.payload;
    },
    setAdminStudentView(state: COURSE_STATE_TYPE, action: PayloadAction<boolean>) {
      state.adminStudentView = action.payload;
    },
    resetActiveCourseData(state: COURSE_STATE_TYPE) {
      state.activeCourseData = INITIAL_STATE.activeCourseData;
    },
  },
});

export const {
  setActiveCourseData,
  setCourseList,
  addToCourseList,
  deleteCourse,
  setisEditingCourseData,
  setAdminStudentView,
  resetActiveCourseData,
} = courseSlice.actions;

export default courseSlice.reducer;
